import { render } from "./scan-tutorial.vue?vue&type=template&id=39cccda8&scoped=true"
import script from "./scan-tutorial.vue?vue&type=script&lang=js"
export * from "./scan-tutorial.vue?vue&type=script&lang=js"

import "./scan-tutorial.vue?vue&type=style&index=0&id=39cccda8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cccda8"]])

export default __exports__